module.exports = __webpack_public_path__ + "static/media/grizepartner.4fe45ea0.svg";